const DAY_PRIORITY_STAGE = '2020-5-20';
const DAY_1_STAGE = '2020-5-27';
const DAY_2_STAGE = '2020-6-3';
const DAY_3_STAGE = '2020-6-8';

export const START_DATE_OF_SCHOL = {

    A1: DAY_1_STAGE,
    A2: DAY_1_STAGE,
    A3: DAY_1_STAGE,
    A4: DAY_1_STAGE,
    A5: DAY_1_STAGE,
    A6: DAY_1_STAGE,
    A7: DAY_1_STAGE,

    G1: DAY_1_STAGE,
    G2: DAY_1_STAGE,
    G3: DAY_2_STAGE,
    G4: DAY_2_STAGE,
    G5: DAY_3_STAGE,
    G6: DAY_3_STAGE,

    G7: DAY_3_STAGE,
    G8: DAY_2_STAGE,
    G9: DAY_1_STAGE,

    G10: DAY_2_STAGE,
    G11: DAY_1_STAGE,
    G12: DAY_PRIORITY_STAGE,

};
